import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="logo-text">微趣AI</span>
            </Link>
          </div>

          <div className="footer-links">
            <div className="footer-col">
              <h4>产品</h4>
              <Link to="/products">智能助手</Link>
              <Link to="/products">AI工作流</Link>
              <Link to="/products">智能会议助理</Link>
              <Link to="/products">公文智能生成</Link>
              <Link to="/products" className="footer-more">更多产品</Link>
            </div>
            <div className="footer-col">
              <h4>行业应用</h4>
              <Link to="/industry">政府部门与公共机构</Link>
              <Link to="/industry">国有企业与央企集团</Link>
              <Link to="/industry">企业组织</Link>
              <Link to="/industry">军工与涉密机构</Link>
              <Link to="/industry" className="footer-more">更多应用</Link>
            </div>
            <div className="footer-col">
              <h4>支持</h4>
              <Link to="/news">信息发布</Link>
              <Link to="/resources">资源下载</Link>
              <Link to="/contact">联系我们</Link>
              <Link to="/contact">预约演示</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 上海微趣网络科技有限公司 版权所有 | <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">沪ICP备13010437号</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;